
import { Component, Prop, Vue } from 'vue-property-decorator'
import InputAnswerText from '@/components/molecules/InputAnswerText.vue'
import KatexMixedText from '@/components/molecules/KatexMixedText.vue'
import ButtonInput from '@/components/organisms/study/ButtonInput.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * テキスト入力イベント発生時の処理型
 */
export type InputTextFunction = (
  question: StudyModel.Question,
  index: number,
  afterFunction: StudyModel.AfterInputFunction
) => void

/**
 * 設問情報の解答欄表示(入力式)
 */
@Component({
  components: {
    InputAnswerText,
    KatexMixedText,
    ButtonInput,
  },
})
export default class InputText extends Vue {
  /** 設問情報 */
  @Prop()
  private question!: StudyModel.Question

  /** テキスト入力時の処理 */
  @Prop()
  private inputText!: InputTextFunction

  /** アクティブな入力欄のインデックス */
  private activeIndex: number = 0

  /** 入力値の更新タイムスタンプ(DOMを更新させるために使う) */
  private updatedAt: number = 0

  /**
   * 表示用要素の取得
   *
   * @returns 入力式の表示用要素(配列)
   */
  private get items(): StudyModel.FrontValueInput[] {
    return this.question.contents.map((content) => {
      return content.frontValues as StudyModel.FrontValueInput
    })
  }

  /**
   * 入力イベント
   *
   * @param index 入力欄のインデックス
   */
  private input(index: number): void {
    this.activeIndex = index
    this.inputText(this.question, index, this.afterFunction)
  }

  /**
   * 入力後の処理
   *
   * @param value 入力された値
   */
  private afterFunction(value: string): void {
    // 値の更新
    this.question.inputValues[this.activeIndex] = value
    // DOM更新のためキー値を書き換え
    this.updatedAt = new Date().valueOf()
  }
}
